import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import { MORTGAGE_CALCULATOR_MF_NAME } from 'shared/constants/microfrontends';
import { useApplicationContext } from 'shared/containers/ApplicationContext';

interface IAvailableResult {
  isAvailable: true;
  manifest: IMicrofrontendManifest;
}

interface INotAvailableResult {
  isAvailable: false;
  manifest: null;
}

export function useMortgageMiniCalculatorMicrofrontend(
  isCalculatorMicrofrontendEnabled: boolean,
): IAvailableResult | INotAvailableResult {
  const { config } = useApplicationContext();
  const manifest = config.get<IMicrofrontendManifest>(`microfrontendManifests.${MORTGAGE_CALCULATOR_MF_NAME}`);

  if (isCalculatorMicrofrontendEnabled && manifest) {
    return {
      isAvailable: true,
      manifest,
    };
  }

  return {
    isAvailable: false,
    manifest: null,
  };
}
